import { EyeOutlined } from "@ant-design/icons";
import { DocumentLibrary } from "@rumble-it/common-lib/types/models/DocumentLibrary.interface";
import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";

export const documentLibraryColumns: TableColumnsType<DocumentLibrary> = [
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (text: string, record: DocumentLibrary) => (
      <Link to={`/document-libraries/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: "Aantal documenten",
    dataIndex: "numberOfDocuments",
    key: "numberOfDocuments",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record: DocumentLibrary) => (
      <Link to={`/document-libraries/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
